module.exports = __webpack_public_path__ + "img/RewardStatement.f9678299.svg";